import { render, staticRenderFns } from "./LossReasonsPieChart.vue?vue&type=template&id=e36df160&scoped=true&"
import script from "./LossReasonsPieChart.vue?vue&type=script&lang=js&"
export * from "./LossReasonsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./LossReasonsPieChart.vue?vue&type=style&index=0&id=e36df160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36df160",
  null
  
)

export default component.exports